import { COLORS, NAV_HEIGHT } from "../../utilities/Constants"

export const generalStyles = {
	page: {
		fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
		backgroundColor: COLORS.bg,
		// La nav occupe déjà NAV_HEIGHT au-dessus de la page : en 100vh la page
		// dépasse de cette hauteur et fait scroller pour rien. `borderBox` est
		// indispensable ici — sans lui (pas de reset global dans l'app) le padding
		// s'ajoute au minHeight et rend 64px de scroll malgré le calc.
		minHeight: `calc(100vh - ${NAV_HEIGHT}px)`,
		boxSizing: "border-box",
		padding: "32px 24px",
		color: COLORS.text,
	},
	header: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		marginBottom: 32,
	},
	ficheNumber: {
		fontSize: 12,
		fontWeight: 500,
		color: COLORS.textLight,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		marginBottom: 4,
	},
	title: {
		fontSize: 26,
		fontWeight: 600,
		color: COLORS.text,
		letterSpacing: "-0.02em",
	},
	badge: (color, bg) => ({
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		padding: "6px 14px",
		borderRadius: 99,
		fontSize: 13,
		fontWeight: 500,
		color,
		backgroundColor: bg,
	}),
	grid3: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: 16,
		marginBottom: 16,
	},
	grid2: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		gap: 16,
		marginBottom: 16,
	},
	card: {
		position: "relative",
		backgroundColor: COLORS.surface,
		borderRadius: 16,
		border: `1px solid ${COLORS.border}`,
		padding: "20px 24px",
		boxSizing: "border-box",
	},
	cardTitle: {
		position: "relative",
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		letterSpacing: "0.1em",
		textTransform: "uppercase",
		marginBottom: 18,
		paddingBottom: 12,
		borderBottom: `1px solid ${COLORS.border}`,
	},
	mt18: {
		marginTop: 18,
	},
	fieldGroup: {
		display: "flex",
		flexDirection: "column",
		gap: 12,
	},
	fieldRow: {
		display: "flex",
		alignItems: "center",
		gap: 8,
	},
	label: {
		fontSize: 12,
		fontWeight: 500,
		color: COLORS.textMuted,
		minWidth: 130,
		flexShrink: 0,
	},
	input: {
		flex: 1,
		padding: "7px 11px",
		border: `1px solid ${COLORS.borderStrong}`,
		borderRadius: 8,
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: COLORS.surface,
		outline: "none",
		fontFamily: "inherit",
		transition: "border-color 0.15s",
		boxSizing: "border-box",
		fontVariantNumeric: "tabular-nums",
	},
	inputReadonly: {
		flex: 1,
		padding: "7px 11px",
		border: `1px solid ${COLORS.border}`,
		borderRadius: 8,
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: "#FAFAF9",
		fontFamily: "inherit",
		boxSizing: "border-box",
		fontVariantNumeric: "tabular-nums",
	},
	select: {
		flex: 1,
		// Place à droite (34px) pour le chevron custom ; la flèche native est
		// retirée (appearance:none) car son offset n'est pas contrôlable.
		padding: "7px 34px 7px 11px",
		border: `1px solid ${COLORS.borderStrong}`,
		borderRadius: 8,
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: COLORS.surface,
		outline: "none",
		fontFamily: "inherit",
		cursor: "pointer",
		boxSizing: "border-box",
		appearance: "none",
		WebkitAppearance: "none",
		MozAppearance: "none",
		backgroundImage:
			"url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2378716C' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\")",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "right 12px center",
		backgroundSize: "12px",
	},
	splitInput: {
		display: "flex",
		gap: 6,
		flex: 1,
	},
	statCard: {
		backgroundColor: COLORS.surface,
		border: `1px solid ${COLORS.border}`,
		borderRadius: 12,
		padding: "14px 18px",
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	statLabel: {
		fontSize: 11,
		fontWeight: 500,
		color: COLORS.textLight,
		textTransform: "uppercase",
		letterSpacing: "0.06em",
	},
	statValue: {
		fontSize: 22,
		fontWeight: 600,
		color: COLORS.text,
		letterSpacing: "-0.02em",
		fontVariantNumeric: "tabular-nums",
	},
	statSub: {
		fontSize: 11,
		color: COLORS.textMuted,
	},
	totalHighlight: {
		backgroundColor: COLORS.text,
		border: `1px solid ${COLORS.text}`,
		borderRadius: 12,
		padding: "14px 18px",
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	conducteurCard: {
		border: `1px solid ${COLORS.border}`,
		borderRadius: 12,
		padding: "16px",
		backgroundColor: COLORS.surface,
		position: "relative",
	},
	conducteurPrimary: {
		border: `1.5px solid ${COLORS.gold}`,
		borderRadius: 12,
		padding: "16px",
		backgroundColor: COLORS.warningLight,
		position: "relative",
	},
	conducteurBadge: {
		position: "absolute",
		top: -10,
		left: 16,
		backgroundColor: COLORS.gold,
		color: "#fff",
		fontSize: 10,
		fontWeight: 600,
		padding: "2px 10px",
		borderRadius: 99,
		letterSpacing: "0.06em",
		textTransform: "uppercase",
	},
	obsItem: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		padding: "10px 14px",
		border: `1px solid ${COLORS.border}`,
		borderRadius: 10,
		backgroundColor: COLORS.surface,
	},
	obsInput: {
		flex: 1,
		border: "none",
		outline: "none",
		fontSize: 13,
		color: COLORS.text,
		backgroundColor: "transparent",
		fontFamily: "inherit",
	},
	// Bouton icône « ghost » : fond blanc, bordure fine neutre, icône teintée par
	// `color`. Plus net et cohérent que l'ancien lavis teinté.
	// Lot 9 (Jordan 30.10) : hauteur commune de la rangée d'en-tête des 3
	// fiches (badge / menu d'état, « Marquer », bascule boss, boutons
	// inter-fiches = iconBtn 32 × 32).
	entete: { height: 32, boxSizing: "border-box" },
	iconBtn: (color) => ({
		width: 32,
		height: 32,
		boxSizing: "border-box",
		borderRadius: 9,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.surface,
		color,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		fontSize: 14,
		flexShrink: 0,
		transition: "border-color 0.15s, background-color 0.15s",
	}),
	addBtn: {
		display: "flex",
		alignItems: "center",
		gap: 6,
		padding: "8px 14px",
		border: `1px dashed ${COLORS.borderStrong}`,
		borderRadius: 10,
		backgroundColor: "transparent",
		color: COLORS.textMuted,
		fontSize: 13,
		cursor: "pointer",
		fontFamily: "inherit",
		width: "100%",
		justifyContent: "center",
		transition: "all 0.15s",
	},
	fixedFooter: {
		position: "fixed",
		display: "flex",
		bottom: 0,
		// Fixé au viewport mais aligné sur le bord droit du contenu des fiches
		// (plafonné à 1600px centré) ; retombe sur 24px en écran étroit.
		right: "max(24px, calc((100vw - 1600px) / 2))",
		justifyContent: "flex-end",
		gap: 10,
		marginBottom: 24,
	},
	footer: {
		display: "flex",
		justifyContent: "flex-end",
		gap: 10,
		marginTop: 24,
	},
	btnSecondary: {
		padding: "10px 20px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.surface,
		color: COLORS.text,
		fontSize: 14,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
	btnPrimary: {
		padding: "10px 24px",
		borderRadius: 10,
		border: "none",
		backgroundColor: COLORS.text,
		color: "#fff",
		fontSize: 14,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
	// État désactivé commun aux boutons de page (primary/secondary) : gris atténué
	// + curseur not-allowed. À appliquer quand `disabled` est vrai.
	btnDisabled: {
		padding: "10px 24px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.border,
		color: COLORS.textLight,
		fontSize: 14,
		fontWeight: 500,
		cursor: "not-allowed",
		fontFamily: "inherit",
	},
	// Bouton destructeur au niveau page (pendant de modalStyles.btnDanger, à
	// l'échelle des boutons de page).
	btnDanger: {
		padding: "10px 24px",
		borderRadius: 10,
		border: `1px solid ${COLORS.dangerBorder}`,
		backgroundColor: COLORS.dangerLight,
		color: COLORS.danger,
		fontSize: 14,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	},
	// Onglets « segmented control » (conteneur pilule + segments) — LE style
	// d'onglets principal des pages V2. Réf : /atelier/inventaire.
	segmented: {
		display: "inline-flex",
		flexWrap: "wrap",
		gap: 2,
		padding: 4,
		backgroundColor: COLORS.bg,
		border: `1px solid ${COLORS.border}`,
		borderRadius: 10,
		marginBottom: 24,
	},
	segment: (active) => ({
		padding: "7px 18px",
		borderRadius: 7,
		border: "none",
		fontFamily: "inherit",
		fontSize: 13,
		fontWeight: 500,
		cursor: "pointer",
		whiteSpace: "nowrap",
		color: active ? COLORS.text : COLORS.textMuted,
		backgroundColor: active ? COLORS.surface : "transparent",
		boxShadow: active ? "0 1px 3px rgba(28, 25, 23, 0.08)" : "none",
		transition: "color 0.12s, background-color 0.12s",
	}),
	// Pastilles secondaires (sous-onglets DANS un onglet) — accent quand actif.
	// Réf : /configuration → Tâches.
	sectionTabs: { display: "flex", gap: 8, marginBottom: 16 },
	sectionTab: (active) => ({
		padding: "7px 16px",
		borderRadius: 8,
		border: `1px solid ${active ? COLORS.accent : COLORS.border}`,
		backgroundColor: active ? COLORS.accentLight : COLORS.surface,
		color: active ? COLORS.accent : COLORS.textMuted,
		fontSize: 14,
		fontWeight: 600,
		cursor: "pointer",
		fontFamily: "inherit",
	}),
}
